import { render, staticRenderFns } from "./PeriodCompare.vue?vue&type=template&id=17107d2b&scoped=true&"
import script from "./PeriodCompare.vue?vue&type=script&lang=js&"
export * from "./PeriodCompare.vue?vue&type=script&lang=js&"
import style0 from "./PeriodCompare.vue?vue&type=style&index=0&id=17107d2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17107d2b",
  null
  
)

export default component.exports